import { Component, OnInit } from '@angular/core';
import { CommunicationsService, Communication } from '../services/communications.service';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CondominiumService } from '../services/condominium.service';
import { GenericConfirmationDialogComponent } from '../shared/delete-confirmation-dialog/generic-confirmation-dialog.component';
import { CreateCommunicationDialogComponent } from './create-communication-dialog/create-communication-dialog.component';
import { PageEvent } from '@angular/material/paginator';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-communications',
    templateUrl: './communications.component.html',
    styleUrls: ['./communications.component.sass'],
    standalone: false
})
export class CommunicationsComponent implements OnInit {
  communications: Communication[] = [];
  totalElements = 0;
  pageSize = 10;
  pageIndex = 0;
  isOwner = false;
  condominiumId: number | null = null;

  constructor(
    private communicationsService: CommunicationsService,
    private condominiumService: CondominiumService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  async ngOnInit() {
    this.route.parent?.url.subscribe(url => {
      let found = false;
      if (url[0].path === 'condominium' && url.length > 1) {
        this.condominiumId = +url[1];
        this.loadCommunications();
        this.checkOwnership();
        found = true;
      }
      if (!found) {
        this.router.navigate(['/condominiums']);
      }
    });
  }

  async checkOwnership() {
    if (this.condominiumId) {
      this.isOwner = await this.condominiumService.isCurrentUserOwnerOfCondominium(this.condominiumId);
    }
  }

  loadCommunications() {
    if (this.condominiumId) {
      this.communicationsService.getCommunications(this.condominiumId, this.pageIndex, this.pageSize)
        .subscribe(response => {
          this.communications = response._embedded.communicationResponseDTOList;
          this.totalElements = response.page.totalElements;
        });
    }
  }

  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.loadCommunications();
  }

  openCreateDialog() {
    const dialogRef = this.dialog.open(CreateCommunicationDialogComponent, {
      width: '500px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.condominiumId) {
        result.condominiumId = this.condominiumId;
        this.communicationsService.createCommunication(result)
          .subscribe({
            next: () => {
              this.snackBar.open('Comunicado criado com sucesso!', 'Fechar', { duration: 3000 });
              this.loadCommunications();
            },
            error: () => {
              this.snackBar.open('Erro ao criar comunicado', 'Fechar', { duration: 3000 });
            }
          });
      }
    });
  }

  openDeleteDialog(communication: Communication) {
    const dialogRef = this.dialog.open(GenericConfirmationDialogComponent, {
      data: {
        title: 'Excluir comunicado',
        message: 'Deseja excluir este comunicado?',
        confirmButtonText: 'Excluir'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.communicationsService.deleteCommunication(communication.id)
          .subscribe({
            next: () => {
              this.snackBar.open('Comunicado excluído com sucesso!', 'Fechar', { duration: 3000 });
              this.loadCommunications();
            },
            error: () => {
              this.snackBar.open('Erro ao excluir comunicado', 'Fechar', { duration: 3000 });
            }
          });
      }
    });
  }

  navigateToDetails(id: number) {
    if (this.condominiumId) {
      this.router.navigate([`/condominium/${this.condominiumId}/communications`, id]);
    }
  }
} 